const updates = [
  {
    date: '2026.07.30',
    title: '暑期档片单全面升级',
    desc: '新增100+部暑期热门影片和剧集，涵盖最新院线大片与高分经典，暑期观影不重样。',
    tag: '片库更新',
  },
  {
    date: '2026.07.28',
    title: '移动端播放器全新优化',
    desc: '移动端播放体验大幅提升，新增手势调节亮度、音量功能，全屏适配更加流畅自然。',
    tag: '功能升级',
  },
  {
    date: '2026.07.25',
    title: '服务器节点扩容完成',
    desc: '新增多地CDN加速节点，全国范围内播放速度提升40%以上，高峰期观影更加稳定流畅。',
    tag: '系统优化',
  },
  {
    date: '2026.07.22',
    title: '韩剧专区重磅上线',
    desc: '全新韩剧分类页面上线，收录近五年高分韩剧全集，从经典到最新一网打尽。',
    tag: '新功能',
  },
  {
    date: '2026.07.18',
    title: '纪录片频道内容扩充',
    desc: '引进了200+部BBC、国家地理等顶级纪录片资源，自然、历史、科技全覆盖。',
    tag: '内容扩充',
  },
  {
    date: '2026.07.15',
    title: '智能推荐算法上线',
    desc: '基于观影偏好和历史记录的智能推荐系统正式启用，帮你发现更多可能喜欢的影片。',
    tag: '功能升级',
  },
  {
    date: '2026.07.10',
    title: '桃花影院三周年特别企划',
    desc: '感谢500万+观众三年来的陪伴与支持，我们将继续坚持免费高清的初心，持续优化观影体验。',
    tag: '站点公告',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          桃花影院的每一次进步，都与你有关
        </p>

        <div className="max-w-[720px] mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>

            <div className="space-y-6">
              {updates.map((item, idx) => (
                <div key={idx} className="relative flex gap-5">
                  <div className="relative z-10 w-[38px] h-[38px] flex items-center justify-center rounded-full bg-primary-500 text-background-50 flex-shrink-0">
                    <i className="ri-flag-line text-sm"></i>
                  </div>
                  <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-300 transition-all duration-200 cursor-default">
                    <div className="flex items-center gap-2 flex-wrap mb-1.5">
                      <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="text-[10px] px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}